import styled from 'styled-components';

import { theme } from '@notino/react-styleguide';

export const ConditionalDiscountProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  margin-bottom: 2rem;
  margin-top: 1rem;
`;

export const DiscountInformationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const DiscountDescription = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ConditionalTextWrapper = styled.div`
  ${theme.typography.labelRegular400}
`;

export const ProgressBarContainer = styled.div`
  width: 75%;
`;

export const ProgressText = styled.div`
  margin-bottom: 1rem;
  font-size: 1.4rem;
`;

export const ProgressBackground = styled.div`
  background-color: ${theme.color.border.divider};
  border-radius: 0.5rem;
  height: 0.25rem;
`;

export const ProgressFill = styled.div<{ progress: number }>`
  width: ${(props) => props.progress}%;
  background-color: ${theme.color.background.highlight};
  height: 100%;
  border-radius: 0.5rem;
`;
